"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _FormInput = _interopRequireDefault(require("./FormInput"));
const _excluded = ["value", "placeholder", "className", "readOnly", "required", "state", "min", "max", "enableDecimal", "managed", "onChange", "onFocus", "onBlur"];
const FormNumber = _ref => {
  let {
      value,
      readOnly,
      required,
      // TODO: handle required
      state,
      min,
      max,
      enableDecimal,
      managed,
      onChange,
      onFocus,
      onBlur
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const {
    isFocus,
    required: inputIsRequired,
    // TODO: Handle required in association with state prop
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    onRequiredChange,
    setState
  } = _react.default.useContext(_FormContext.default);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: managed !== true && isFocus
  }), [isFocus, managed]);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValueManager)(value, internalValueOptions);
  const [inputValue, setInputValue] = (0, _arkReact.useInternalValue)((0, _ark.isValidNumber)(value) ? value.toString() : undefined);
  _react.default.useEffect(() => setState?.(state), [state]);
  _react.default.useEffect(() => onRequiredChange?.(required ?? false), [required, onRequiredChange]);
  const handleInputChange = _react.default.useCallback((newValue, event) => {
    let newNumberValue;
    if ((0, _ark.isString)(newValue)) {
      let formatedValue;
      if ((0, _ark.isDefined)(enableDecimal) && enableDecimal === true) {
        formatedValue = newValue.replace(',', '.');
        newNumberValue = parseFloat(formatedValue);
      } else {
        formatedValue = newValue.replace(/[\.,].*/, '');
        newNumberValue = parseInt(formatedValue, 10);
      }
      setInputValue(formatedValue);
      if ((0, _ark.isNaN)(newNumberValue)) newNumberValue = undefined;
    } else setInputValue(newValue);
    setInternalValue(newNumberValue);
    onChange?.(newNumberValue, event);
  }, [onChange, setInternalValue, setInputValue]);
  const handleInputBlur = _react.default.useCallback((_value, event) => {
    onInputBlur?.();
    onBlur?.(internalValue, event);
  }, [onInputBlur, onBlur, internalValue]);
  const handleInputFocus = _react.default.useCallback(event => {
    onInputFocus?.();
    onFocus?.(event);
  }, [onInputFocus, onFocus]);
  return /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({
    type: "number",
    required: required,
    min: min,
    max: max,
    value: inputValue ?? undefined,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    readOnly: readOnly,
    managed: true
  }, props));
};
process.env.NODE_ENV !== "production" ? FormNumber.propTypes = {
  value: (0, _arkReact.propTypeAllowUndefined)(_ark.isValidNumber),
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  enableDecimal: _propTypes.default.bool,
  icon: _propTypes.default.node,
  managed: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
} : void 0;
FormNumber.defaultProps = {
  value: undefined,
  className: undefined,
  placeholder: undefined,
  readOnly: undefined,
  required: undefined,
  min: undefined,
  max: undefined,
  enableDecimal: false,
  icon: undefined,
  managed: false,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined
};
var _default = exports.default = FormNumber;